const INITIAL_STATE = {
  managementStatus: { values: [], error: null, loading: false },
};

export default function (state = INITIAL_STATE, action) {
  return {
    ...state,
    managementStatus: { values: action.payload, error: null, loading: true },
  };
}
